import { mutate } from 'swr';
import { getCacheKey } from 'utils/getCacheKey';

export const mutateProjectTypes = () => {
  const searchedKey = getCacheKey('/project_types');
  if (searchedKey) {
    mutate(searchedKey);
  }
};
